import React, { useState } from "react";
import "./assignment.css";
import "./assignment-reservation.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import AssignmentReservation from "./assignment-reservation";
import axios from 'axios';
import Swal from "sweetalert2";

function Assignment() {
  const [masterValueAssign, setMasterValueAssign] = useState("");
  const [viewAssign, setViewAssign] = useState("input");
  const [error, setError] = useState("");
  const [guia, setGuia] = useState('');
  const [masterData, setMasterData] = useState('');
  const [masterValue, setMasterValue] = useState('');


  const handleInputChange = (e) => {
    setMasterValueAssign(e.target.value);
    setGuia(e.target.value)
    setError("");
  };

  const handleSearch = async () => {
    const pattern = /^\d{3}-\d+$/;
    const userData = localStorage.getItem("user");
    const user = JSON.parse(userData);
    if (pattern.test(masterValueAssign.trim())) {
      try {
        const master = guia;
        const getUserId = () => {
          const user = JSON.parse(localStorage.getItem("user") || "null");
          return user?.id || "";
        };
        const res = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_assignation/getMaster`,
          {
            params: { master, user_id: getUserId()}, //user.id },
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        if (res.data.code == 1) {
          setMasterData(res.data);
          setViewAssign("form");
        }else{
          Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Error. Intente nuevamente", "error");
        console.log(error);
      }
    } else {
      setError("Ingrese el vuelo correctamente")
    }
  };

  const handleSuccessFromChild = (masterId) => {
        setMasterValue(masterId);       // actualiza el input
        setTimeout(() => {
            setViewAssign('form');
            handleSearch();               // luego lanza búsqueda con el nuevo valor
        }, 0); 
    };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid assignment-text">
        {viewAssign === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                onChange={handleInputChange}
              />
              {error && (
                <div className="text-danger mt-2">
                  {error}
                </div>
              )}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {viewAssign === "form" && (
          <AssignmentReservation masterNumber={masterValueAssign} onSuccess={handleSuccessFromChild} masterData={masterData} />
        )}
      </div>
    </>
  );
}

export default Assignment;
